import React from "react";

class OrderContextRouteAdapter extends React.Component {
  componentDidMount() {
    const { history, location } = this.props;
    history.replace({
      pathname: "/",
      search: location.search,
      hash: location.hash,
      state: {
        ...(location.state || {}),
        openOrderOptions: true,
        legacyOrderContextPath: location.pathname,
      },
    });
  }

  render() {
    return null;
  }
}

export default OrderContextRouteAdapter;
